import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { getTestIds } from '../../../../utils/TestIds';
import { Row } from '../../../Layout';
import { ActionsCell } from '../cells/ActionsCell/ActionsCell';
import { SchemaCell } from '../cells/SchemaCell/SchemaCell';
import { cardCellEditing, columnName } from '../mobileCard/mobileCard';
export function CardActions(param) {
    let { row, content, now, editing, pending, cardTestId } = param;
    const cardTestIds = getTestIds(cardTestId);
    const own = content.actions != null ? /*#__PURE__*/ _jsx(ActionsCell, {
        variant: "card",
        actions: content.actions,
        row: row,
        testId: cardTestIds.actions()
    }) : content.badge != null ? /*#__PURE__*/ _jsx(SchemaCell, {
        column: content.badge,
        row: row,
        now: now,
        testId: cardTestIds.badge()
    }) : null;
    if (content.trailing == null) return own;
    const trailingName = columnName(content.trailing);
    return /*#__PURE__*/ _jsxs(Row, {
        gap: 12,
        alignItems: "center",
        children: [
            own,
            /*#__PURE__*/ _jsx(SchemaCell, {
                column: content.trailing,
                row: row,
                now: now,
                pending: pending && content.trailing.showsLoaderWhilePending === true,
                editing: cardCellEditing(editing, content.trailing),
                testId: cardTestIds.value(trailingName)
            })
        ]
    });
}
